import React from 'react';

const EscrowDetailActions = ({ actions, escrow }) => {
  return (
    <div className="mb-6">
      <div className="bg-gray-800 rounded-xl border border-gray-700 p-4 backdrop-blur-sm">
        <div className="flex flex-wrap gap-3">
          {actions?.map((action, index) => (
            <button
              key={index}
              onClick={action.onClick}
              className={`px-4 py-2.5 text-white rounded-lg transition-all duration-200 font-medium flex items-center hover:scale-[1.02] ${action.color}`}
            >
              <span className="mr-2">{action.icon}</span>
              {action.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default EscrowDetailActions;